import getApi from '../api/getApi';
import postApi from '../api/postApi';
import axiosInstance from '../api/rootApi';

/** GET /fixedProducts — returns 6 featured pets for the homepage */
export const fetchFeaturedPets = () => getApi('/fixedProducts');

/** GET /products — returns all pets for the explore page */
export const fetchAllPets = () => getApi('/products');

/** GET /products/:id — returns a single pet by ID */
export const fetchPetById = (id) => getApi(`/products/${id}`);

/** POST /products — add a new pet */
export const addPet = (data) => postApi('/products', data);

/** DELETE /products/:id — delete a pet by ID */
export const deletePet = (id) => axiosInstance.delete(`/products/${id}`).then((r) => r.data);
